<!-- eslint-disable -->
<template>
  <CommonPages id="name-detail" :class="['name-detail']" :titlePrefix="nameData.name">
    <div v-if="nameData.name" class="detail-container" :class="deviceType">
      <!-- Main Name Detail Card -->
      <div class="name-detail-card" :style="{ background: nameData.background }">
        <div v-if="deviceType === 'mobile'" class="expand-toggle" @click="isExpanded = !isExpanded">
          <div class="expand-text">{{ isExpanded ? 'Pack Up' : 'Expand all' }}</div>
          <img src="@/assets/default/arrow-down.svg" :class="{ 'expanded': isExpanded }"
            alt="arrow" />
        </div>
        <div class="card-title-header">
          <div class="name-main-info">
            <h1 class="name-title">{{ nameData.name }}</h1>
            <!-- <p class="name-pronunciation">{{ nameData.pronunciation }}</p> -->
          </div>
        </div>

        <div class="info-pills">
          <div class="info-pill">
            <span class="pill-label">Pronunciation</span>
            <span class="pill-value">{{ nameData.pronunciation }}</span>
          </div>
          <div class="info-pill">
            <span class="pill-label">Gender</span>
            <span class="pill-value">{{ nameData.gender }}</span>
          </div>
          <div class="info-pill">
            <span class="pill-label">US Popularity</span>
            <span class="pill-value">{{ nameData.popularity }}</span>
          </div>
          <div class="info-pill">
            <span class="pill-label">Origin</span>
            <span class="pill-value">{{ nameData.origin }}</span>
          </div>
          <div class="info-pill">
            <span class="pill-label">Style</span>
            <span class="pill-value">{{ nameData.style }}</span>
          </div>
          <div class="info-pill " v-if="deviceType !== 'mobile' || isExpanded">
            <span class="pill-label">Meaning</span>
            <span class="pill-value">
              {{ nameData.meaningList ? nameData.meaningList.join(', ') : nameData.meaning }}
            </span>
          </div>
        </div>

        <template v-if="deviceType !== 'mobile' || isExpanded">
          <p class="name-description">{{ nameData.description }}</p>

          <div class="card-divider"
            v-if="nameData.nicknameList && nameData.nicknameList.length > 0">
          </div>

          <div class="nicknames-section"
            v-if="nameData.nicknameList && nameData.nicknameList.length > 0">
            <h2 class="nicknames-title">Common Nicknames for {{ nameData.name }}</h2>
            <div class="nicknames-list">
              <div class="nickname-item" v-for="(nickname, index) in nameData.nicknameList"
                :key="index">
                <span>{{ nickname }}</span>
              </div>
            </div>
          </div>
        </template>
      </div>

      <AdComponent :key="'ads-name-detail-1'" v-if="deviceType !== 'mobile'"
        v-show="$global.isObjectNotEmpty(adsensConfig) && adsensConfig?.name_detail_1"
        ref="ads-name-detail-1" class="ad-width-100 " :ads="adsensConfig?.name_detail_1"
        :showDebug="showDebug" />

      <!-- Similar Names Section -->
      <div class="similar-name-section" :class="[deviceType]" v-if="similarNames.length > 0">
        <div class="section-header" :class="[deviceType]">
          <div class="section-title">Similar Names</div>
        </div>
        <div class="similar-names-list" :class="[deviceType]">
          <template v-for="(card, index) in similarNames">
            <router-link :key="index" :to="`/names/${card.name.toLowerCase()}/${card.id}`" tag="div"
              class="name-card-link">
              <div class="name-card" :style="{ background: card.background }">
                <div class="card-header">
                  <div class="card-info">
                    <div class="card-name">{{ card.name }}</div>
                    <div class="card-pronunciation">{{ card.pronunciation }}</div>
                  </div>
                  <div class="card-gender-icon">
                    <img :src="card.genderIcon" alt="gender icon" />
                  </div>
                </div>
                <div class="card-details">
                  <div class="detail-row">
                    <span class="detail-label">US Popularity</span>
                    <span class="detail-value">{{ card.popularity }}</span>
                  </div>
                  <div class="detail-row">
                    <span class="detail-label">Style</span>
                    <span class="detail-value">{{ card.style }}</span>
                  </div>
                  <div class="detail-row">
                    <span class="detail-label">Meaning</span>
                    <span class="detail-value text-ellipsis">
                      {{ card.meaningList.join(', ') }}
                    </span>
                  </div>
                </div>
              </div>
            </router-link>
            <AdComponent v-if="deviceType === 'mobile' && index === 0" :key="'ads-name-detail-1'"
              v-show="$global.isObjectNotEmpty(adsensConfig) && adsensConfig?.name_detail_1"
              ref="ads-name-detail-1" class="ad-width-100 " :ads="adsensConfig?.name_detail_1"
              :showDebug="showDebug" />
            <AdComponent v-if="deviceType === 'mobile' && index === 2" :key="'ads-name-detail-2'"
              v-show="$global.isObjectNotEmpty(adsensConfig) && adsensConfig?.name_detail_2"
              ref="ads-name-detail-2" class="ad-width-100 " :ads="adsensConfig?.name_detail_2"
              :showDebug="showDebug" />
            <AdComponent v-if="deviceType === 'mobile' && index === 4" :key="'ads-name-detail-3'"
              v-show="$global.isObjectNotEmpty(adsensConfig) && adsensConfig?.name_detail_3"
              ref="ads-name-detail-3" class="ad-width-100 " :ads="adsensConfig?.name_detail_3"
              :showDebug="showDebug" />
          </template>
        </div>
      </div>

    
      <!-- Combinations Section -->
      <div class="combinations-section" :class="[deviceType]" v-if="combinations.length > 0">
        <div class="section-header">
          <div class="section-title">Combinations</div>
        </div>
        <div class="combinations-container">
          <div class="combination-row" :class="[deviceType]">
            <div class="combination-card-link" v-for="(combo, index) in combinations" :key="index"
              @click="navigateTo(combo.url)" @mouseenter="hoveredCombination = index"
              @mouseleave="hoveredCombination = null">
              <div class="combination-card" :class="{'hovered': hoveredCombination === index}">
                <div class="combination-text">{{ combo.title }}</div>
                <div class="see-more-button">
                  <span>See More</span>
                  <img src="@/assets/default/arrow-right-small_w.svg" alt="arrow"
                    class="arrow-icon" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Search by Filter Section -->
      <section class="search-sec-row" :class="[deviceType]">
        <div class="section-header" :class="[deviceType]">
          <div class="section-title">Search by Filter</div>
        </div>
        <div class="names-filter" :class="[deviceType]">
          <SearchFilter />
        </div>
      </section>
    </div>
  </CommonPages>
</template>

<script>
import common from '@/mixin/common.js'
import adMixin from '@/mixin/adMixin.js'
import adTrackingMixin from '@/mixin/adTrackingMixin.js'
import { mapGetters } from 'vuex';
import CommonPages from '@/pages/components/page_common.vue'
import SearchFilter from '@/components/SearchFilter.vue';
import AdComponent from '@/pages/components/AdComponent.vue'
import '@/css/common.scss';

export default {
  name: 'NameDetail',
  components: {
    CommonPages,
    SearchFilter,
    AdComponent,
  },
  mixins: [common, adMixin, adTrackingMixin],
  data () {
    return {
      isExpanded: false,
      hoveredCard: null,
      hoveredCombination: null,
      isGenerateHovered: false,
      isResetHovered: false,
      nameData: {},
      similarNames: [],
      combinations: [],
    };
  },
  computed: {
    ...mapGetters([
      "adsensConfig",
      'adPosConfig',
      'showDebug',
      'deviceType',
      'domainConfig',
      'gender',
      'style',
      'meaning'
    ]),
    pageTitle () {
      const name = this.nameData?.name || '';
      return name ? `${name} - Meaning and Origin` : '';
    },
    pageDescription () {
      const name = this.nameData?.name || '';
      const origin = this.domainConfig?.origin || '';
      // eslint-disable-next-line max-len
      return name && origin ? `Discover the meaning, pronunciation, and cultural background of the ${origin} name ${name}.` : '';
    },
    genderIcon () {
      if (!this.nameData.gender) return null
      if (this.nameData.gender === 'Boy') {
        return require('@/assets/icons/male.png')
      } else if (this.nameData.gender === 'Unisex') {
        return require('@/assets/icons/unsex.png')
      } else {
        return require('@/assets/icons/female.png')
      }
    },
    genderOptions () {
      if (!this.gender || this.gender.length === 0) return [{ value: 'all', label: 'All' }];
      return [{ value: 'all', label: 'All' }, ...this.gender.map(item => ({ label: item, value: item }))];
    },
    styleOptions () {
      if (!this.style || this.style.length === 0) return [{ value: 'all', label: 'All' }];
      return [{ value: 'all', label: 'All' }, ...this.style.map(item => ({ label: item, value: item }))];
    },
    meaningOptions () {
      if (!this.meaning || this.meaning.length === 0) return [{ value: 'all', label: 'All' }];
      return [{ value: 'all', label: 'All' }, ...this.meaning.map(item => ({ label: item, value: item }))];
    },
  },
  methods: {
    resetFilters () {
      this.filters = JSON.parse(JSON.stringify(this.defaultFilters));
    },
    generateNames () {
      // 构建查询参数
      const queryParams = {};

      // 添加非默认值的过滤条件到查询参数
      Object.keys(this.filters).forEach(key => {
        if (this.filters[key] !== 'all') {
          queryParams[key] = this.filters[key];
        }
      });

      // 导航到名字列表页面，带上查询参数
      this.$router.push({
        path: '/names',
        query: queryParams
      });
    },
    async fetchNameDetail () {
      const { id } = this.$route.params;
      if (!id) return;
      try {
        const response = await this.$global.server.postAPI({
          method: 'get',
          params: { id },
          url: '/name/detail',
        });
        if (response.data) {
          const GENDER_COLORS = {
            Boy: 'linear-gradient(180deg, #0088FF 0%, rgba(0, 136, 255, 0.2) 100%)',
            Girl: 'linear-gradient(180deg, #E54CBA 0%, rgba(229, 76, 186, 0.2) 100%)',
            Unisex: 'linear-gradient(180deg, #C8AD17 0%, rgba(200, 173, 23, 0.2) 100%)',
          };
          this.nameData = {
            ...response.data,
            background: GENDER_COLORS[response.data.gender] || GENDER_COLORS.Unisex,
          };
          this.fetchSimilarNames(this.nameData);
          this.fetchCombinations(this.nameData);
        }
      } catch (error) {
        console.error('Error fetching name detail:', error);
        this.nameData = {};
      }
    },
    async fetchSimilarNames (nameData) {
      if (!nameData.style) return;
      try {
        const params = {
          pageSize: '8',
          pageNum: '1',
          style: nameData.style,
          sortType: 'S_3'
        };
        if (this.domainConfig && this.domainConfig.origin) {
          params.origin = this.domainConfig.origin;
        }
        const response = await this.$global.server.postAPI({
          method: 'post',
          params,
          url: '/name/page',
        });
        if (response.data && response.data.list) {
          const GENDER_COLORS = {
            Boy: 'linear-gradient(180deg, #0088FF 0%, rgba(0, 136, 255, 0.2) 100%)',
            Girl: 'linear-gradient(180deg, #E54CBA 0%, rgba(229, 76, 186, 0.2) 100%)',
            Unisex: 'linear-gradient(180deg, #C8AD17 0%, rgba(200, 173, 23, 0.2) 100%)',
          };
          this.similarNames = response.data.list
            .filter(item => String(item.id) !== String(this.nameData.id))
            .map(item => ({
              id: item.id || '',
              name: item.name || 'N/A',
              gender: item.gender,
              genderIcon: item.gender === 'Boy'
                ? require('@/assets/icons/male.svg')
                : item.gender === 'Unisex'
                  ? require('@/assets/icons/unsex.svg')
                  : require('@/assets/icons/female.svg'),
              pronunciation: item.pronunciation || 'N/A',
              style: item.style || 'N/A',
              meaning: item.meaning || 'N/A',
              meaningList: item.meaningList || [],
              popularity: item.popularity || 'N/A',
              background: GENDER_COLORS[item.gender] || GENDER_COLORS.Unisex,
            }));
        }
      } catch (error) {
        console.error('Error fetching similar names:', error);
      }
    },
    async fetchCombinations (nameData) {
      if (!nameData.origin) return;
      try {
        const params = { origin: nameData.origin };
        if (nameData.gender) {
          params.gender = nameData.gender;
        }
        const response = await this.$global.server.postAPI({
          method: 'get',
          params,
          url: '/name/combinations',
        });
        if (response.data && response.data.combinations) {
          this.combinations = response.data.combinations.slice(0, 4);
        }
      } catch (error) {
        console.error('Error fetching combinations:', error);
      }
    },
    navigateTo (url) {
      if (url) {
        this.$router.push(url);
      }
    }
  },
  async mounted () {
    this.fetchNameDetail();
    await this.initAdSystem();
    // 确保在广告系统初始化后再初始化跟踪
    this.$nextTick(() => {
      this.initAdTracking();
    });
  }
};
</script>

<style lang="scss" scoped>
@import '~@/css/variables.scss';

.name-detail {
	background-color: #000;
	color: #fff;

	.detail-container {
		padding: rem(20) rem(180);

		&.mobile {
			padding: rem(20) rem(16);
		}
	}

	.name-detail-card {
		border-radius: rem(16);
		padding: rem(24);
		display: flex;
		flex-direction: column;
		gap: rem(16);
		margin-bottom: rem(32);

		.expand-toggle {
			display: flex;
			align-items: center;
			gap: rem(8);
			cursor: pointer;
			.expand-text {
				color: #fff;
				font-size: rem(13);
				font-style: normal;
				font-weight: 900;
				line-height: rem(14); /* 107.692% */
			}
			img {
				width: rem(12);
				height: rem(6);
				transition: transform 0.3s ease;
				&.expanded {
					transform: rotate(180deg);
				}
			}
		}

		.name-main-info {
			.name-title {
				font-size: rem(40);
				font-weight: 900;
				line-height: rem(52);
			}
			.name-pronunciation {
				font-style: italic;
				opacity: 0.8;
			}
		}

		.info-pills {
			display: flex;
			flex-wrap: wrap;
			gap: rem(8);

			.info-pill {
				background: rgba(255, 255, 255, 0.1);
				border-radius: rem(12);
				padding: rem(12) rem(16);
				display: flex;
				flex-direction: column;
				gap: rem(8);
				// flex-grow: 1;

				.pill-label {
					font-size: rem(12);
					font-weight: 300;
				}

				.pill-value {
					font-size: rem(14);
				}
			}
			.info-pill-meaning {
				flex-basis: 100%;
			}
		}

		.name-description {
			font-size: rem(12);
			line-height: rem(20);
		}

		.card-divider {
			border-top: 1px dashed rgba(255, 255, 255, 0.1);
		}

		.nicknames-section {
			.nicknames-title {
				font-size: rem(16);
				font-weight: 900;
				margin-bottom: rem(12);
			}

			.nicknames-list {
				display: flex;
				flex-wrap: wrap;
				gap: rem(8);

				.nickname-item {
					background: rgba(255, 255, 255, 0.1);
					border-radius: rem(8);
					padding: rem(8) rem(16);
					font-size: rem(14);
					cursor: pointer;
					transition: background 0.3s ease;

					&:hover {
						background: linear-gradient(92.87deg, #0088ff 0%, #e54cba 50%, #c8ad17 100%);
					}
				}
			}
		}
	}

	.similar-name-section,
	.combinations-section,
	.search-sec-row {
		padding: rem(40) 0;
	}

	.section-header {
		margin-bottom: rem(24);
		.section-title {
			color: #fff;
			font-size: rem(24);
			font-weight: 900;
		}
	}

	.similar-names-list {
		display: grid;
		grid-template-columns: repeat(4, 1fr);
		gap: rem(24);

		.name-card-link {
			text-decoration: none;
		}

		.name-card {
			border-radius: rem(16);
			padding: rem(16);
			display: flex;
			flex-direction: column;
			gap: rem(16);
			color: #fff;
			cursor: pointer;
			transition: transform 0.3s ease;

			&:hover {
				transform: translateY(rem(-4));
			}

			.card-header {
				display: flex;
				justify-content: space-between;
				align-items: flex-start;

				.card-info {
					.card-name {
						font-size: rem(20);
						font-weight: 900;
					}
					.card-pronunciation {
						font-size: rem(12);
						font-style: italic;
					}
				}

				.card-gender-icon {
					width: rem(24);
					height: rem(24);
					background: #fff;
					border-radius: rem(8);
					display: flex;
					align-items: center;
					justify-content: center;
					img {
						width: rem(16);
						height: rem(16);
					}
				}
			}

			.card-details {
				display: flex;
				flex-direction: column;
				gap: rem(8);

				.detail-row {
					background: rgba(255, 255, 255, 0.1);
					border-radius: rem(8);
					padding: rem(8) rem(12);
					display: flex;
					justify-content: space-between;
					align-items: center;

					.detail-label {
						font-size: rem(12);
						opacity: 0.8;
					}
					.detail-value {
						font-size: rem(13);
						font-weight: 700;
					}
					.text-ellipsis {
						white-space: nowrap;
						overflow: hidden;
						text-overflow: ellipsis;
						max-width: rem(120);
						text-align: right;
					}
				}
			}
		}
	}

	.combinations-section {
		.combinations-container .combination-row {
			display: grid;
			grid-template-columns: repeat(4, 1fr);
			gap: rem(24);
		}

		.combination-card-link {
			text-decoration: none;
			padding: rem(2);
			border-radius: rem(16);
			background: transparent;
			transition: all 0.3s ease;
			&:hover {
				background: linear-gradient(93deg, #08f 0%, #e54cba 50%, #c8ad17 100%);
			}
		}

		.combination-card {
			background: rgba(255, 255, 255, 0.1);
			border-radius: rem(14);
			padding: rem(24);
			display: flex;
			flex-direction: column;
			justify-content: space-between;
			height: rem(172);
			box-sizing: border-box;
			cursor: pointer;

			.combination-text {
				color: #fff;
				font-size: rem(18);
				font-weight: 700;
			}

			.see-more-button {
				background: linear-gradient(92.87deg, #0088ff 0%, #e54cba 50%, #c8ad17 100%);
				border-radius: rem(8);
				padding: rem(8) rem(16);
				display: flex;
				align-items: center;
				justify-content: center;
				gap: rem(8);
				width: rem(100);

				span {
					color: #fff;
					font-size: rem(12);
					font-weight: 700;
				}
				.arrow-icon {
					width: rem(6);
					height: rem(10);
					filter: brightness(0) invert(1);
				}
			}
		}
	}

	.search-sec-row {
		padding-bottom: rem(40);
	}

	&.detect_deviece_mobile {
		.detail-container.mobile {
			padding: rem(20) rem(16);
		}
		// .name-detail-card {
		// 	.card-title-header {
		// 		display: flex;
		// 		align-items: center;
		// 		.name-main-info {
		// 			flex-grow: 1;
		// 			text-align: center;
		// 		}
		// 	}
		// }
		.similar-names-list {
			grid-template-columns: 1fr;
			gap: rem(16);
		}
		.combinations-section {
			.combinations-container .combination-row {
				display: flex;
				overflow-x: auto;
				gap: rem(16);
				padding: 0 rem(16);
				margin: 0 rem(-16);
				&::-webkit-scrollbar {
					display: none;
				}
				-ms-overflow-style: none;
				scrollbar-width: none;
			}
			.combination-card-link {
				flex-shrink: 0;
				width: rem(280);
			}
		}

		.info-pills {
			.info-pill {
				// flex-basis: calc(50% - 4px);
			}
		}
	}
}
</style> 